/** Excepciones de calidad de datos. Se reportan; nunca se corrigen en el origen. */

import { useState } from "react";
import { api } from "../api/client";
import { useAsync } from "../api/useAsync";
import type { Severity } from "../api/types";
import { ErrorState, Loading } from "../components/States";
import { StatusBadge } from "../components/StatusBadge";
import { severityLabel, severityTone } from "../components/tones";
import { formatDate } from "../components/format";

const FILTERS: { value: Severity | ""; label: string }[] = [
  { value: "", label: "Todas" },
  { value: "blocking", label: "Bloqueantes" },
  { value: "warning", label: "Advertencias" },
  { value: "info", label: "Informativas" },
];

export function Exceptions() {
  const [severity, setSeverity] = useState<Severity | "">("");
  const { data, error, loading } = useAsync(
    () => api.exceptions(severity || undefined),
    [severity],
  );

  return (
    <>
      <div className="page-head">
        <div>
          <h1>Excepciones de calidad</h1>
          <p>
            La plataforma reporta los huecos del histórico fiscal; no los rellena en
            el origen ni los inventa. Una excepción no bloquea un período en el que la regla
            todavía no aplicaba.
          </p>
        </div>
      </div>

      <div className="toolbar">
        <div className="field">
          <label htmlFor="severity">Severidad</label>
          <select
            id="severity"
            value={severity}
            onChange={(event) => setSeverity(event.target.value as Severity | "")}
          >
            {FILTERS.map((filter) => (
              <option key={filter.value} value={filter.value}>
                {filter.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      {loading && <Loading what="las excepciones" />}
      {error && <ErrorState error={error} />}

      {data && (
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th scope="col">Severidad</th>
                <th scope="col">Período</th>
                <th scope="col">Código</th>
                <th scope="col">Documento</th>
                <th scope="col">Detalle</th>
              </tr>
            </thead>
            <tbody>
              {data.length === 0 && (
                <tr>
                  <td colSpan={5} className="muted">
                    Sin excepciones registradas para este filtro.
                  </td>
                </tr>
              )}
              {data.map((exception, index) => (
                <tr key={`${exception.exception_code}-${exception.move_name}-${index}`}>
                  <td>
                    <StatusBadge tone={severityTone(exception.severity)}>
                      {severityLabel(exception.severity)}
                    </StatusBadge>
                  </td>
                  <td>{formatDate(exception.period_month)}</td>
                  <td className="mono small">{exception.exception_code}</td>
                  <td className="mono small">{exception.move_name ?? "—"}</td>
                  <td className="small">{exception.detail}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
